import * as React from 'react';
import { MenuOption, MenuOptionGroup } from '../types';
import { CarouselEditor } from './CarouselEditor';
import { OptionsListEditor } from './OptionListEditor';
import { isCarouselConfig } from './utils';
import { AddOptionModal } from './AddOptionModal';

interface OptionGroupEditorProps {
  isPOSItem: boolean;
  optionType: {
    [optionGroupId: string]: boolean;
  };
  addOptions({ optionGroupId, options }: { optionGroupId: string; options: MenuOption[] });
  updateOption({
    optionGroupId,
    oldOption,
    newOption,
  }: {
    optionGroupId: string;
    oldOption: MenuOption;
    newOption: MenuOption;
  });
  deleteOption({ optionGroupId, option }: { optionGroupId: string; option: MenuOption });
  toggleOptionType(optionGroupId);
  moveOption(optionGroupId: string, dragIndex: number, hoverIndex: number);
  optionGroup: MenuOptionGroup;

  optionLookUpVariables: {
    venueId: string;
    menuId: string;
    categoryId: string;
    itemId?: string;
  };
}

export const OptionGroupEditor: React.FC<OptionGroupEditorProps> = (props) => {
  const { optionGroup, addOptions, isPOSItem } = props;

  const [isAdding, setIsAdding] = React.useState(false);
  const onClickAdd = React.useCallback(() => {
    setIsAdding(true);
  }, [setIsAdding]);

  const onCancelAdd = React.useCallback(() => {
    setIsAdding(false);
  }, [setIsAdding]);

  const onSubmitNew = React.useCallback(
    (options: MenuOption[]) => {
      setIsAdding(false);

      addOptions({
        optionGroupId: optionGroup.id,
        options,
      });
    },
    [addOptions, optionGroup]
  );

  if (isCarouselConfig(optionGroup.editorConfig)) {
    return (
      <>
        <CarouselEditor
          optionGroup={optionGroup}
          onClickAdd={onClickAdd}
          updateOption={props.updateOption}
          deleteOption={props.deleteOption}
          moveOption={props.moveOption}
          isPriceEditable={!isPOSItem}
        />
        <AddOptionModal
          isOpen={isAdding}
          onSubmit={onSubmitNew}
          onCancel={onCancelAdd}
          optionGroup={optionGroup}
          isPOSItem={isPOSItem}
          {...props.optionLookUpVariables}
        />
      </>
    );
  } else {
    return (
      <>
        <OptionsListEditor
          optionGroup={optionGroup}
          disabled={!props.optionType[optionGroup.id]}
          updateOption={props.updateOption}
          deleteOption={props.deleteOption}
          onToggleDisabled={props.toggleOptionType}
          onClickAdd={onClickAdd}
          isPOSItem={isPOSItem}
        />
        <AddOptionModal
          isOpen={isAdding}
          onSubmit={onSubmitNew}
          onCancel={onCancelAdd}
          optionGroup={optionGroup}
          isPOSItem={isPOSItem}
          {...props.optionLookUpVariables}
        />
      </>
    );
  }
};
